import _ from 'lodash';
import utils from 'lib/utils';
import qs from 'query-string';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchRoles = async (params = {}) => {
  try {
    const qs = reqTransform.fetchRoles(params);
    const url = `${baseUrl}/BioFuelRegistration/api/ReferenceData/GetRoles?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchRoles(resData);
  } catch (err) {
    const errors = await utils.processApiErrors(err, '', 'GetRoles');
    throw errors;
  }
};
